import React, { forwardRef, useImperativeHandle, useRef } from "react"
import { css } from "@emotion/core"

function round(number, precision) {
  var shift = function (number, precision, reverseShift) {
    if (reverseShift) {
      precision = -precision
    }
    var numArray = ("" + number).split("e")
    return +(
      numArray[0] +
      "e" +
      (numArray[1] ? +numArray[1] + precision : precision)
    )
  }
  return shift(Math.round(shift(number, precision, false)), precision, true)
}

export default forwardRef((props, ref) => {
  let { max, value = 0, load = 0, onClick, onMouseMove } = props
  const styles = props.css
  const divRef = useRef()
  useImperativeHandle(ref, () => divRef.current)
  return (
    <div
      ref={divRef}
      className="progress"
      css={[
        css`
          display: inline-flex;
          overflow: hidden;
          width: 50px;
          background-color: grey;
          cursor: pointer;
          height: 0.5rem;

          .value {
            display: block;
            height: 100%;
            width: ${round((value / max) * 100, 2)}%;
            background-color: green;
          }
          .load {
            display: block;
            height: 100%;
            width: ${round(((load - value) / max) * 100, 2)}%;
            background-color: blue;
          }

          background-color: var(--base3);
          border: 1px solid var(--base2);
          border-radius: 0.25rem;
          .value {
            background-color: var(--base03);
          }
          .value:hover,
          .value:focus {
            background-color: var(--base02);
          }
          .load {
            background-color: var(--base3);
          }
        `,
        styles,
      ]}
      onClick={onClick}
      onMouseMove={onMouseMove}
    >
      {value && value > 0 ? <div class="value"></div> : ""}
      {load && load - value > 0 ? <div class="load"></div> : ""}
    </div>
  )
})
